import { SDropdownMenu } from '@setvi/shared/components';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MenuItemProps } from '.';
import { Item } from './Item';

interface IMenuItemDropdown extends MenuItemProps {
  collapsedDrawer: boolean;
  menuItems: MenuItemProps[];
}

export const MenuItemDropdown = ({
  collapsedDrawer,
  title,
  menuItems,
  icon
  // baseRoute
}: IMenuItemDropdown) => {
  const navigate = useNavigate();
  const items = useMemo(
    () =>
      menuItems.map(el => ({
        icon: el.icon,
        text: el.title,
        divider: el.divider,
        dividerAlign: el.dividerAlign,
        onClick: el.onClick || (() => navigate(el.route))
      })),
    [navigate, menuItems]
  );
  const location = useLocation();

  // Only select if current route matches a visible (non-hidden) child route
  const isSelected = useMemo(
    () =>
      menuItems.some(item => !item.hidden && location.pathname === item.route),
    [menuItems, location.pathname]
  );

  return (
    <SDropdownMenu
      menuItems={items}
      anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
      transformOrigin={{ vertical: 'center', horizontal: 'left' }}>
      <Item
        selected={isSelected}
        title={title}
        icon={icon}
        collapsedDrawer={collapsedDrawer}
      />
    </SDropdownMenu>
  );
};
